export default "__VITE_ASSET__BRhNEok8__"